module.exports = __webpack_public_path__ + "img/Texas_A&M_University_Logo.fbf492d2.png";